
import {Component,OnInit,  ViewChild, AfterViewInit} from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { Http, Headers, Response } from '@angular/http';
import {ModalDirective} from 'ng2-bootstrap/ng2-bootstrap';
import {Observable} from 'rxjs/Rx';
import { Router }            from '@angular/router';
import {Location}           from '@angular/common';
import { ApplicationContextService }         from './app-context.service';
import { QuickLinkComponent }         from './quicklink.component';
import { ClientRecord }                from './client.record';
import {ColorMode }         from './app-context.service';


@Component({
 //  moduleId: module.id,
  selector: 'consult-detail',
  templateUrl: './consult-detail.component.html',
  styleUrls:  ['./content-detail.component.css','./consult-detail.component.css']
})
export class ConsultDetailComponent implements OnInit {
 @ViewChild('smTypeErr') public smTypeErr: ModalDirective; 
  @ViewChild('smConfirm') public smConfirm: ModalDirective; 
@ViewChild('smPostErr') public smPostErr: ModalDirective; 
private formProcessUrl = 'http://www.renoa.cz/atelier/webapi/messages'; // URL to JSON file
  private cRec: ClientRecord;
 private bsubmitting: boolean;

  data:any;
  error:any;

 
   constructor(
    private appContextService: ApplicationContextService,
     private location: Location,    
    private router: Router,
    private http:Http) { }

  ngOnInit(): void {
     this.cRec = this.appContextService.GetClientRecord();
     this.appContextService.SetMode(ColorMode.White);

  }

   goBack(): void {
      this.location.back();

  }


leavePage(): void {
  setTimeout(() => { this.router.navigate([this.appContextService.GetURL()]);  }, 200);   
}

smPostErrClose(): void {

  this.smPostErr.hide();
  this.leavePage();
}
smConfirmClose(): void {

  this.smConfirm.hide();
  this.leavePage();
}
isInSubmit(): boolean {
  return this.bsubmitting; 
}

submit(): void {

     this.appContextService.SetClientRecord(this.cRec);  // NOT NECESSARY, SAME OBJECT POINTER
     if((this.cRec.phone.length >=  9) || 
        ((this.cRec.email.length >= 5) && (this.cRec.email.indexOf('@') >= 0)))
     {    

        this.bsubmitting = true; 
        let headers = new Headers();
        
        headers.append('X-SyncTimeout','30');
        headers.append('Accept','application/json');
        headers.append('Cache-Control','no-cache');
        headers.append('Content-Type','application/json');
        headers.append('Access-Control-Allow-Origin', '*');

        this.http.post(this.formProcessUrl,JSON.stringify(this.cRec),{headers: headers})
                .catch(err =>  {
                     this.smPostErr.show();
                     this.bsubmitting = false; 
                    return Observable.throw(err); 
                  })           
                //.publishLast().refCount()
                // .map((res: Response) => 
                //       {
                //         console.log('RESPONSE:' + res);
                //        })
                  .subscribe(
                      data => {console.log(data); this.smConfirm.show()},
                      err =>  {console.log(err); this.smPostErr.show()},
                      () => {this.bsubmitting = false; console.log('authenticated'); }
                   );
  

       }
     else   {this.smTypeErr.show();   }


  }

}